import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../lotties';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
var defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid',
    },
};
var LoadingResultAnimation = function (_a) {
    var loadingMessage = _a.loadingMessage, messageColor = _a.messageColor;
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        }, children: [_jsx(Lottie, { options: defaultOptions, height: 300, width: 300, style: { maxWidth: '100%', transform: 'scale(1.2)' } }), loadingMessage && (_jsx(Typography, { variant: "h5", textAlign: "center", color: messageColor, children: loadingMessage }))] }));
};
export default LoadingResultAnimation;
